/**
 * Unified Error Alert Component
 * Provides consistent error display across the application
 */
import React from 'react';
import { Alert } from 'react-bootstrap';
import { useI18n } from '../i18n';

const ErrorAlert = ({ 
  error, 
  onDismiss, 
  variant = 'danger',
  dismissible = true,
  showDetails = false,
  className = ''
}) => {
  const { t } = useI18n();
  if (!error) return null;

  const errorMessage = typeof error === 'string' ? error : error.message;
  const errorCode = error.code;
  const errorDetails = error.details;
  const requestId = error.requestId;

  return (
    <Alert 
      variant={variant} 
      dismissible={dismissible} 
      onClose={onDismiss}
      className={`error-alert ${className}`}
    >
      <div className="error-message">
        {errorMessage}
      </div>
      
      {showDetails && (errorCode || requestId) && (
        <div className="error-details mt-2 small text-muted">
          {errorCode && (
            <div>{t('errors:errorCode', { defaultValue: 'Error Code:' })} <code>{errorCode}</code></div>
          )}
          {requestId && (
            <div>{t('errors:requestId', { defaultValue: 'Request ID:' })} <code>{requestId}</code></div>
          )}
          {process.env.NODE_ENV === 'development' && errorDetails && (
            <details className="mt-1">
              <summary style={{ cursor: 'pointer' }}>{t('errors:debugDetails', { defaultValue: 'Debug Details' })}</summary>
              <pre className="mt-1 small">
                {JSON.stringify(errorDetails, null, 2)}
              </pre>
            </details>
          )}
        </div>
      )}
    </Alert>
  );
};

export default ErrorAlert;
